export default __webpack_public_path__ + "static/media/returns.e30f70a3.png";